import OrderStrategy from "./OrderStrategy";

export const Disabled = OrderStrategy(0, 'edi.orders.add_order.order_lifecycle.executor_edit_strategy.select.0')
export const All = OrderStrategy(1, 'edi.orders.add_order.order_lifecycle.executor_edit_strategy.select.1')
export const ItemQuantityToLowerValueOnly = OrderStrategy(2, 'edi.orders.add_order.order_lifecycle.executor_edit_strategy.select.2')